import './Card.css';

function Card(props) {

    return (
        <div id='card' className={props.class ? 'card-dark-mode' : 'card-light-mode'}>
            <img src={props.flag} alt='flag'></img>
            <div className='text'>
                <h4>{props.name}</h4>
                <p><b>Population:</b> {props.population.toLocaleString()}</p>
                <p><b>Region:</b> {props.region}</p>
                <p><b>Capital:</b> {props.capital}</p>
            </div>
        </div>
    )
}

export default Card